import React from "react"
import styled from "styled-components"

import { Container, Row, Col } from "../Grid"
import Snippet from "../Snippet"
import Spacer from "../Spacer"
import StyledCategoryCard, { CardHeader } from "../CategoryCard"
import Button from "../Button"
import Link from "../Link"
import { ButtonRow } from "../FormFields"

import { media, mixins } from "../../styles"

const Wrapper = styled.div``

const Header = styled.div`
  margin-bottom: 30px;
  text-align: center;

  @media ${media.md} {
    margin-bottom: 40px;
    padding: 0 50px;
  }

  @media ${media.lg} {
    margin-bottom: 50px;
  }

  @media ${media.xl} {
    margin-bottom: 70px;
  }

  h2 {
    ${mixins.title3}
  }
`

const CardCol = styled(Col)`
  @media ${media.xl} {
    flex: 0 0 20%;
    max-width: 20%;
  }
`

const CategoryCard = styled(StyledCategoryCard)`
  ${CardHeader} {
    margin-right: -20px; // allow for a little more space to acccomodate the arrow
  }
`

const HomeServices = ({ productCollections }) => {
  // Normalize productCollections by moving slugs (internal products)
  // and URLs (external products) to `to` field
  const normalizedProductCollections = [...productCollections].map(
    (collection) => ({
      ...collection,
      links: collection.links.map((item) => ({
        ...item,
        to: item.slug ? `/services/${item.slug}/` : item.url,
      })),
    })
  )

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col sm="10" smOffset="1" md="8" mdOffset="2">
            <Header>
              <h2>
                <Snippet id="homeServices" field="header" />
              </h2>
            </Header>
          </Col>
        </Row>
        <Row mdJustifyContent="center">
          {normalizedProductCollections.map((item, i) => (
            <CardCol sm="6" md="4" xl="3" key={i}>
              <CategoryCard category={item} headerLevel={3} />
            </CardCol>
          ))}
        </Row>
        <Spacer height={60} />
        <ButtonRow>
          <Button
            arrow
            as={Link}
            to={Snippet({ id: "homeServices", field: "linkUrl" })}
            intl={false}
          >
            {Snippet({ id: "homeServices", field: "linkText" })}
          </Button>
        </ButtonRow>
      </Container>
    </Wrapper>
  )
}

export default HomeServices
